module.exports = __webpack_public_path__ + "fonts/learningful-glyphs_a6f0f447f971e8c2fd516dd40385e89b.69178d6.woff";